export default __webpack_public_path__ + "static/media/server_down.44056c84.svg";